export default __webpack_public_path__ + "static/media/file.cea57fb9.svg";